import { useEffect, useState } from "react";

const HEIGHT_KEY = "dp_selected_height";
const COLOR_KEY = "dp_selected_color";
const HEIGHT_EVENT = "dp:height-change";
const COLOR_EVENT = "dp:color-change";

export const HEIGHTS = [
  { key: "Medium", label: "Medium", cm: "15 cm" },
  { key: "High", label: "High", cm: "18 cm" },
];

export const COLORS = [
  { key: "Classic White", swatch: "#ffffff", label: "Classic White", image: "/assets/color_white.png" },
  { key: "Premium Grey", swatch: "#9aa0a6", label: "Premium Grey", image: "/assets/color_grey.png" },
  { key: "Royal Blue", swatch: "#5c7cb8", label: "Royal Blue", image: "/assets/color_blue.png" },
  { key: "Brown Luxury", swatch: "#a4806e", label: "Brown Luxury", image: "/assets/color_brown.png" },
  { key: "Pink Queen", swatch: "#f0c0c8", label: "Pink Queen", image: "/assets/color_pink.png" },
];

export const HIGH_HEIGHT_UPCHARGE = 10;

// ── Height ────────────────────────────────────────────────────────────
export function getStoredHeight() {
  if (typeof window === "undefined") return "Medium";
  return localStorage.getItem(HEIGHT_KEY) || "Medium";
}

export function setStoredHeight(height) {
  if (typeof window === "undefined") return;
  localStorage.setItem(HEIGHT_KEY, height);
  window.dispatchEvent(new CustomEvent(HEIGHT_EVENT, { detail: height }));
}

export function useSelectedHeight() {
  const [h, setH] = useState(() => getStoredHeight());
  useEffect(() => {
    const handler = (e) => setH(e.detail);
    window.addEventListener(HEIGHT_EVENT, handler);
    return () => window.removeEventListener(HEIGHT_EVENT, handler);
  }, []);
  return h;
}

// ── Color ─────────────────────────────────────────────────────────────
export function getStoredColor() {
  if (typeof window === "undefined") return "Classic White";
  return localStorage.getItem(COLOR_KEY) || "Classic White";
}

export function setStoredColor(color) {
  if (typeof window === "undefined") return;
  localStorage.setItem(COLOR_KEY, color);
  window.dispatchEvent(new CustomEvent(COLOR_EVENT, { detail: color }));
}

export function useSelectedColor() {
  const [c, setC] = useState(() => getStoredColor());
  useEffect(() => {
    const handler = (e) => setC(e.detail);
    window.addEventListener(COLOR_EVENT, handler);
    return () => window.removeEventListener(COLOR_EVENT, handler);
  }, []);
  return c;
}
